const gratis_of_bestel = (window.location.host.includes('gratis') ? 'gratis-luchtfoto' : 'bestelluchtfoto');
export const is_gratis = gratis_of_bestel === 'gratis-luchtfoto';
export default gratis_of_bestel;
